<script src="router/index.js"></script>
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {}
    },
    methods: {
      _isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
        );
        return flag;
      },
    },
    mounted() {
      // if (this._isMobile()) {
      //   // 手机端
      //   this.$router.replace({name: "mobileHome"})
      // } else {
      //   // pc端
      //   this.$router.replace({name: "home"})
      // }
      const that = this
      window.onresize = () => {
        return (() => {
          const width= document.body.clientWidth
          if (width>800) {
            that.$router.replace({name:"home"})
          } else {
            that.$router.replace({name:"mobileHome"})
          }
        })()
      }
    }
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue